import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ag-page_assets position-relative" }
const _hoisted_2 = { class: "form-group d-flex align-items-center" }
const _hoisted_3 = { for: "IsEnabled" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, " on ", -1)
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { for: "HostName" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { for: "Port" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_error_message = _resolveComponent("error-message")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ag_card = _resolveComponent("ag-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ag_card, { module: _ctx.module }, {
      "syslog-settings": _withCtx(() => [
        _createVNode(_component_Form, {
          class: "p-4",
          onSubmit: _ctx.onSubmit,
          "validation-schema": _ctx.schema,
          "initial-values": _ctx.formValues
        }, {
          default: _withCtx(({ meta }) => [
            _createVNode(_component_Field, {
              name: "IsEnabled",
              class: "mb-4"
            }, {
              default: _withCtx(({ field, meta }) => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("label", _hoisted_3, [
                    _createTextVNode(_toDisplayString(_ctx.$t("syslogServerEnable")) + " ", 1),
                    _hoisted_4
                  ]),
                  _createVNode(_component_Toggle, _mergeProps({
                    modelValue: _ctx.formValues.IsEnabled,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formValues.IsEnabled) = $event)),
                    name: "IsEnabled"
                  }, field, {
                    class: ["ml-3", { 'form-error-input': meta.touched && !meta.valid }],
                    onChange: _ctx.toggleStatus
                  }), null, 16, ["modelValue", "onChange", "class"]),
                  _hoisted_5,
                  _createVNode(_component_error_message, {
                    class: "form-error-label",
                    name: "IsEnabled"
                  })
                ])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_Field, { name: "HostName" }, {
              default: _withCtx(({ field, meta }) => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("label", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$t("syslogServerIp")) + " ", 1),
                    _hoisted_8
                  ]),
                  _withDirectives(_createElementVNode("input", _mergeProps({
                    name: "HostName",
                    type: "text",
                    maxlength: "191"
                  }, field, {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formValues.HostName) = $event)),
                    class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
                    id: "HostName"
                  }), null, 16), [
                    [_vModelText, _ctx.formValues.HostName]
                  ]),
                  _createVNode(_component_error_message, {
                    class: "HostName-error-label",
                    name: "HostName"
                  })
                ])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_Field, { name: "Port" }, {
              default: _withCtx(({ field, meta }) => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_ctx.$t("connectionPort")) + " ", 1),
                    _hoisted_11
                  ]),
                  _withDirectives(_createElementVNode("input", _mergeProps({
                    name: "Port",
                    type: "text",
                    maxlength: "191",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formValues.Port) = $event))
                  }, field, {
                    class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
                    id: "Port"
                  }), null, 16), [
                    [_vModelText, _ctx.formValues.Port]
                  ]),
                  _createVNode(_component_error_message, {
                    class: "form-error-label",
                    name: "Port"
                  })
                ])
              ]),
              _: 2
            }, 1024),
            _createElementVNode("button", {
              type: "submit",
              disabled: !meta.valid,
              class: "border-0 pr-4 pl-4 pt-1 pb-1 ag-button ag-button_primary"
            }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_12)
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "initial-values"])
      ]),
      _: 1
    }, 8, ["module"])
  ]))
}